import SingleLink from './single-link';

export default SingleLink;
